"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcornPrimaryContentSuspense = void 0;
var react_1 = __importDefault(require("react"));
var morse_react_1 = require("morse-react");
var FetchingSuspense_1 = require("./FetchingSuspense");
var SuspenseContentStatus_1 = require("../../types/SuspenseContentStatus");
var EmptyDataSuspenseContent = function (props) {
    if (props.isList) {
        return react_1.default.createElement("p", null, SuspenseContentStatus_1.SuspenseContentStatus.ListEmpty);
    }
    else {
        return react_1.default.createElement("p", null, SuspenseContentStatus_1.SuspenseContentStatus.ItemEmpty);
    }
};
var FetchingDataSuspenseContent = function (props) {
    if (!props.itemFetchingStatus.fetched || props.itemFetchingStatus.fetchingSlowlyDebounced) {
        return (react_1.default.createElement("div", { className: 'c-alert +loading' },
            react_1.default.createElement("div", { className: 'c-loader' }),
            react_1.default.createElement("div", { className: 'c-alert__text' }, SuspenseContentStatus_1.SuspenseContentStatus.Loading)));
    }
    else {
        return react_1.default.createElement(react_1.default.Fragment, null, props.children);
    }
};
var FetchingDataSlowlySuspenseContent = function (props) {
    // While we may actually have the item - if we tripped fetchingSlowly, we actually want
    // to delay the suspense going away so we don't get flicker
    if (!props.itemFetchingStatus.fetched || props.itemFetchingStatus.fetchingSlowlyDebounced) {
        return react_1.default.createElement(FetchingDataSuspenseContent, __assign({}, props));
    }
    else {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(morse_react_1.Loader, null),
            props.children));
    }
};
var AcornPrimaryContentSuspense = function (props) {
    return (react_1.default.createElement(FetchingSuspense_1.FetchingSuspense, __assign({ emptyComponent: EmptyDataSuspenseContent, fetchingSlowlyComponent: FetchingDataSlowlySuspenseContent }, props)));
};
exports.AcornPrimaryContentSuspense = AcornPrimaryContentSuspense;
//# sourceMappingURL=AcornPrimaryContentSuspense.js.map